import { Button, Group, Space } from '@mantine/core';
import { IconCopyCheck } from '@tabler/icons-react';
import { useRef } from 'react';
import { useModal } from '../../hooks/useModal';
import { lightGreyIconButtonStyle } from '../../theme/styling/buttonStyling';
import { defaultIconStyle } from '../../theme/styling/iconStyling';
import { SmallModal, type SmallModalProps } from '../SmallModal';

type FormButtonsProps = {
	close: () => void;
	onClick?: () => void;
	buttonText?: string;
	reducePaddingTop?: boolean;
	confirmModalProps?: Partial<SmallModalProps>;
};

export function FormButtons({
	close,
	buttonText,
	onClick,
	reducePaddingTop = false,
	confirmModalProps,
}: FormButtonsProps) {
	const submitButtonRef = useRef<HTMLButtonElement>(null);
	const confirmModal = useModal();

	return (
		<>
			{confirmModalProps && (
				<SmallModal
					title={'Are you sure?'}
					body={'Please confirm to continue...'}
					{...confirmModalProps}
					isOpen={confirmModal.isOpen}
					close={confirmModal.close}
					onComplete={() => {
						confirmModal.close();

						submitButtonRef.current?.closest('form')?.requestSubmit();
					}}
				/>
			)}
			<Space h={reducePaddingTop ? 10 : 30} />
			<Group justify={'space-between'}>
				<Button
					variant={'white'}
					c={'medepos.1'}
					onClick={() => close()}
					data-cy={'cancel-button'}
				>
					Cancel
				</Button>
				<Button
					{...lightGreyIconButtonStyle}
					ref={submitButtonRef}
					type={confirmModalProps ? 'button' : 'submit'}
					onClick={() => {
						onClick?.();
						if (confirmModalProps) confirmModal.open();
					}}
					data-cy={'submit-button'}
				>
					<IconCopyCheck {...defaultIconStyle} />
					<>
						<Space w={10} />
						{buttonText ?? 'Save'}
					</>
				</Button>
			</Group>
		</>
	);
}
